import * as _ from 'lodash';
import { AUTOMATIC_GROUP_HEADER } from '../constants/module.constants';
export const getAnalysisGroupHeaders = (automaticAnalysisTemplateList, values, newAnalysisCreated = false) => {
    let runningAnalyisListLength = 0;
    const automaticAnalysisGroup = {
        id: AUTOMATIC_GROUP_HEADER,
        name: AUTOMATIC_GROUP_HEADER,
        type: 'Untriggered',
        analysisList: automaticAnalysisTemplateList,
    };
    return _.map([automaticAnalysisGroup, ...values], (analysisGroup, index, groups) => {
        const numActiveTemplates = _.filter(analysisGroup.analysisList, (template) => template.isActive).length;
        const openLastGroup = newAnalysisCreated && index === groups.length - 1;
        const group = getAnalysisGroupHeader(analysisGroup, index, numActiveTemplates, runningAnalyisListLength, openLastGroup);
        runningAnalyisListLength += numActiveTemplates;
        return group;
    });
};
export const getAnalysisGroupHeader = (analysisGroup, index, activeLength, runningAnalyisListLength, openGroup = false) => ({
    key: analysisGroup.id,
    name: analysisGroup.name,
    startIndex: runningAnalyisListLength,
    count: activeLength,
    level: 0,
    isCollapsed: !openGroup,
    data: { isAuto: index === 0 },
});

//# sourceMappingURL=AnalysisGroupHeaders.js.map
